export const APP_PAGE_NAMES = [
  { path: "", name: "Home" },
  { path: "/dashboard", name: "Dashboard" },
  { path: "/latest-updates", name: "Latest Updates" },
  { path: "/companies", name: "Companies" },
  { path: "/investors", name: "Investors" },
  { path: "/funding-rounds", name: "Funding Rounds" },
  { path: "/government-fundings", name: "Government Funding" },
  { path: "/government-opportunities", name: "Government Opportunities" },
  { path: "/partnerships", name: "Partnerships" },
  { path: "/partnerships/graph", name: "Partnerships Graph" },
  { path: "/graph-explorer", name: "Graph Explorer" },
  { path: "/groups-and-centers", name: "Groups and Centers" },
  { path: "/universities", name: "Universities" },
  { path: "/enterprise-users", name: "Enterprise Users" },
  { path: "/governments", name: "Government Entities" },
  { path: "/reports", name: "Reports" },
  { path: "/taxonomy", name: "Taxonomy" },
  { path: "/profile", name: "Profile" },
  { path: "/consortiums", name: "Consortia" },
  { path: "/consortiums/map", name: "Consortia Map" },
  { path: "/admin-dashboard", name: "Admin Dashboard" },
  { path: "/graphing-tool", name: "Graphing Tool" },
  { path: "/graphing-tool-rounds", name: "Graphing Tool Rounds" },
  { path: "/analysis-tool", name: "Analysis Tool" },
  { path: "/market-map", name: "Market Map" },
  { path: "/market-map/investors", name: "Market Map Investors" },
  { path: "/market-map/users", name: "Market Map Users" },
  { path: "/map", name: "Map View" },
  { path: "/heat-map", name: "Heat Map" },
  { path: "/quantum-cloud/", name: "Quantum Cloud Providers" },
  { path: "/quantum-cloud/qpu-metrics", name: "Quantum QPU Metrics" },
  { path: "/quantum-cloud/glossary", name: "Quantum Cloud Glossary" },
  { path: "/quantum-cloud/contact", name: "Quantum Cloud Contact" },
  { path: "/news-feed", name: "News Engine Home" },
  { path: "/search-engine", name: "Search Engine" },
  { path: "/analysis-graph", name: "Analysis" },
  { path: "/stories", name: "Stories" },
  { path: "/media-monitoring", name: "Media Monitoring" },
  { path: "/media-monitoring/analysis", name: "Media Monitoring Analysis" },
  { path: "/use-cases", name: "Use Cases" },
  { path: "/patents", name: "Patents" },
  { path: "/patents/list", name: "Patents List" },
  { path: "/patents/stats", name: "Patents Stats" },
  { path: "/research-papers", name: "Research Papers" },
  { path: "/research-papers/list", name: "Research Papers List" },
  { path: "/research-papers/stats", name: "Research Papers Stats" },
];

export function getRouteName(path: string): string | null {
  const route = APP_PAGE_NAMES.find((route) => route.path === path);
  return route ? route.name : null;
}
